/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileUserIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File User',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M28.677 28.542v-1.4a.966.966 0 0 1 .246-.623 7.366 7.366 0 0 0 1.675-4.6c0-3.479-1.845-5.424-4.633-5.424s-4.686 2.021-4.686 5.424a7.447 7.447 0 0 0 1.756 4.6.965.965 0 0 1 .246.623v1.389a.958.958 0 0 1-.836.967c-5.6.487-6.439 4.319-6.439 5.83L16 36h20v-.667c0-1.448-.989-5.266-6.49-5.825a.963.963 0 0 1-.833-.966Z"
    />
    <path
      d="M16 2 6 12h10Zm13 0H18v11a1 1 0 0 1-1 1H6v19a1 1 0 0 0 1 1h6.139a8.711 8.711 0 0 1 6.551-7.041 10.262 10.262 0 0 1-1.41-5.031c0-4.959 3.16-8.424 7.686-8.424A7.55 7.55 0 0 1 30 14.625V3a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
